/* saluvivo: Bewegung beim Scrollen (einmalig, nur transform/opacity).
   Nur Desktop mit Maus; auf Handy/Tablet und bei «weniger Bewegung» steht alles sofort da.
   Texte erscheinen als ganze Blöcke (kein Wort-für-Wort mehr). */
(function(){
  if(window.svLoaded)return;window.svLoaded=true;
  var mm=window.matchMedia;
  var rm=mm&&mm('(prefers-reduced-motion: reduce)').matches;
  var desk=mm&&mm('(min-width:990px) and (hover:hover) and (pointer:fine)').matches;
  var reduce=rm||!desk;
  var SEL='[data-sv-reveal],[data-sv-group],[data-sv-words],[data-sv-media]';
  var io=null,shrink=[],ticking=false;
  function logos(scope){
    scope.querySelectorAll('img.sv-logo').forEach(function(img){
      function set(w,h){if(w&&h)img.style.setProperty('--sv-ar',(w/h).toFixed(3));}
      set(parseFloat(img.getAttribute('width')),parseFloat(img.getAttribute('height')));
      if(img.complete)set(img.naturalWidth,img.naturalHeight);else img.addEventListener('load',function(){set(img.naturalWidth,img.naturalHeight);},{once:true});
    });
  }
  function prep(scope){
    if(reduce)return;
    scope.querySelectorAll('[data-sv-stagger]').forEach(function(g){
      [].slice.call(g.children).forEach(function(c,i){c.style.transitionDelay=(Math.min(i,4)*70)+'ms';});
    });
  }
  function reveal(scope){
    var els=[].slice.call(scope.querySelectorAll(SEL)).filter(function(e){return !e.classList.contains('is-in');});
    if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
    if(!io)io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:0.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  function onScroll(){
    ticking=false;var vh=window.innerHeight;
    shrink.forEach(function(el){
      var r=el.getBoundingClientRect();if(r.bottom<0||r.top>vh)return;
      var p=Math.min(Math.max(-r.top/(r.height||1),0),1);
      el.style.transform=p?'scale('+(1-p*.05).toFixed(4)+')':'';
      el.style.opacity=p?(1-p*.4).toFixed(3):'';
    });
  }
  function rails(scope){
    scope.querySelectorAll('[data-sv-root]').forEach(function(root){
      if(root.getAttribute('data-sv-rails'))return;root.setAttribute('data-sv-rails','1');
      var rail=root.querySelector('.sv-rail');if(!rail)return;
      root.querySelectorAll('[data-sv-dir]').forEach(function(b){b.addEventListener('click',function(){rail.scrollBy({left:rail.clientWidth*.8*Number(b.getAttribute('data-sv-dir')),behavior:rm?'auto':'smooth'});});});
    });
  }
  function init(scope){
    scope=scope||document;logos(scope);prep(scope);reveal(scope);rails(scope);
    if(!reduce){scope.querySelectorAll('[data-sv-shrink]').forEach(function(el){if(shrink.indexOf(el)<0)shrink.push(el);});onScroll();}
  }
  if(!reduce)window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(onScroll);}},{passive:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  window.svInit=init;
})();
